import { PaginatedResult } from '@nx-smartmonkey/shared/interfaces';
import { Client } from '../../domain/client/Client';
import { ClientActionType, ClientActions } from './actions';
import { ClientsTableColumn, getClientsTableColumns, setClientsTableColumns } from './tableColumns';

export interface ClientState {
  clients: PaginatedResult<Client>;
  tableColumns: Array<ClientsTableColumn>;
}

export const getInitialState = (): ClientState => ({
  clients: {
    limit: 20,
    offset: 0,
    total: 0,
    docs: [],
  },
  tableColumns: getClientsTableColumns(),
});

export const ClientReducer = (state: ClientState, action: ClientActions): ClientState => {
  switch (action.type) {
    case ClientActionType.SET_CLIENTS_TABLE_COLUMNS:
      setClientsTableColumns(action.payload);
      return {
        ...state,
        tableColumns: action.payload,
      };
    case ClientActionType.SEARCH_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload.clients,
      };
    default:
      return state;
  }
};
